import { v4 as uuidv4 } from 'uuid';

export function FormInputDropdown(props = {}, childrenComponents = []) {
	return {
		componentName: 'FormInputDropdown',
		componentId: uuidv4(),
		props: Object.assign(
			{
				pointer: '',
				label: '',
			},
			props,
		),
		childrenComponents,
	};
}
